import React, { useState, useRef, useEffect } from 'react';
import { patchLead } from '../api';

const LeadCommentsRow = ({ lead, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [comments, setComments] = useState(lead.comments || '');
  const commentRef = useRef(null);

  const toggleEdit = (e) => {
    setIsEditing(true);
    e.stopPropagation();
  };

  const handleOutsideClick = (event) => {
    if (commentRef.current && !commentRef.current.contains(event.target)) {
      handleSave();
    }
  };

  const handleSave = async () => {
    const updatedComment = commentRef.current?.value.trim() || '';
    
    if (updatedComment !== (lead.comments || '')) {
      try {
        await patchLead(lead.id, { comments: updatedComment });
        if (onUpdate) onUpdate();
      } catch (error) {
        console.error('Error updating comments:', error);
      }
    }
    
    setIsEditing(false);
  };

  const handleChange = (e) => {
    setComments(e.target.value);
  };

  useEffect(() => {
    if (isEditing) {
      document.addEventListener('click', handleOutsideClick);
      return () => document.removeEventListener('click', handleOutsideClick);
    }
  }, [isEditing]);

  return (
    <div style={{ padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
      <label>Comentarios: </label>
      {!isEditing ? (
        <span
          style={{ cursor: 'pointer', fontWeight: 'normal', color: '#007bff', marginLeft: '4px' }}
          onClick={toggleEdit}
        >
          {comments || 'Sin comentarios'}
        </span>
      ) : (
        <textarea
          ref={commentRef}
          value={comments}
          onChange={handleChange}
          rows="3"
          style={{ width: '100%', marginTop: '5px' }}
          autoFocus
          data-testid="lead-comments-textarea"
        />
      )}
    </div>
  );
};

export default LeadCommentsRow;